import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { ChannelSendModel }
from '../../models/configuration/channel-send.model';

import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class GetChannelSendUseCase implements UseCase< void, ChannelSendModel > {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute():
    Observable<ChannelSendModel> {
        return this.repository.getChannelSend();
    }
}